// import components
import Campgrounds from '@/components/campgrounds/Campgrounds'
import Campsites from '@/components/campgrounds/Campsites'
import Blackouts from '@/components/campgrounds/Blackouts'
// export routes

export default [
  {
    path: 'create',
    component: Campgrounds
  },
  {
    path: 'edit',
    component: Campsites
  },
  {
    path: 'blackouts',
    component: Blackouts
  }
]
